module.exports = __webpack_public_path__ + "static/media/publish-herdy.d6a89190.svg";